export const ErrorType = Object.freeze({
    ABORT_ERROR: 'Abort Error',
    CANCEL_ERROR: 'CanceledError',
});
